import api from './api';

// Persist form submissions to the backend CMS.
export const saveSubmission = async (type, data) => {
  const map = { appointments: 'appointment', contacts: 'contact', careers: 'career' };
  const payload = {
    type: map[type] || type,
    name: data.name || '',
    email: data.email || '',
    phone: data.phone || '',
    service: data.service || '',
    position: data.position || '',
    message: data.message || ''
  };
  try {
    await api.post('/submissions', payload);
    return true;
  } catch (e) {
    console.error('submission failed', e);
    return false;
  }
};
